/**
 * Soft-resume helpers for PIN re-entry (no second cash-opening modal).
 */

/**
 * @param {Array<{ workerId?: * }>|null|undefined} activeSessions
 * @param {string|number|null|undefined} workerId
 */
export function hasOpenCashSessionForWorker(activeSessions, workerId) {
  if (workerId == null || workerId === '') return false;
  const selfId = String(workerId);
  return (Array.isArray(activeSessions) ? activeSessions : []).some(
    (s) => s && String(s.workerId || '') === selfId
  );
}
